import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SLICES_NAMES } from 'constants/app';

import { IMarketDefinitionItem, MarketDefinitionsState } from './type';

const initialState: MarketDefinitionsState = {
  markets: {}
};

const slice = createSlice({
  name: SLICES_NAMES.MARKET_DEFINITIONS,
  initialState,
  reducers: {
    setMarketDefinition: (state, { payload }: PayloadAction<IMarketDefinitionItem[]>) => {
      payload.map(market => {
        state.markets[market.marketId] = market;
      });
    },
    resetMarketDefinition: (state, _) => {
      state.markets = {};
    }
  }
});

export const { setMarketDefinition, resetMarketDefinition } = slice.actions;

export default slice.reducer;
